"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHasCompilationError = exports.clearNewFileError = exports.setNewFileError = exports.clearRenameFileError = exports.setRenameFileError = exports.setAllEditorMetadata = exports.setOrderedTabKeys = exports.setFileMetadata = exports.setActiveTabKey = exports.setEditTabKey = exports.closeEditorDialog = exports.openEditorDialog = exports.removeFile = exports.sourceFileOrderUpdated = exports.sourceValidationUpdated = exports.sourceVisibilityUpdated = exports.sourceTextUpdated = exports.renameFile = exports.setAllSourcesAndFileMetadata = exports.setAllValidation = exports.setSource = exports.getValidation = exports.getSources = exports.initialState = void 0;
/**
 * Redux store for editor-specific Java Lab state.
 */
var JavalabFileHelper_1 = require("../JavalabFileHelper");
var lodash_1 = __importDefault(require("lodash"));
var toolkit_1 = require("@reduxjs/toolkit");
var types_1 = require("../types");
var initialSources = {
    'MyClass.java': { text: '', tabOrder: 0, isVisible: true, isValidation: false },
};
var _b = (0, JavalabFileHelper_1.fileMetadataForEditor)(initialSources), fileMetadata = _b.fileMetadata, orderedTabKeys = _b.orderedTabKeys, activeTabKey = _b.activeTabKey, lastTabKeyIndex = _b.lastTabKeyIndex;
// exported for testing
exports.initialState = {
    fileMetadata: fileMetadata,
    orderedTabKeys: orderedTabKeys,
    activeTabKey: activeTabKey,
    lastTabKeyIndex: lastTabKeyIndex,
    sources: initialSources,
    validation: {},
    editorOpenDialogName: null,
    newFileError: null,
    renameFileError: null,
    editTabKey: null,
    hasCompilationError: false,
};
var javalabEditorSlice = (0, toolkit_1.createSlice)({
    name: 'javalabEditor',
    initialState: exports.initialState,
    reducers: {
        setSource: {
            reducer: function (state, action) {
                var _a;
                var _b = action.payload, filename = _b.filename, source = _b.source, tabOrder = _b.tabOrder, _c = _b.isVisible, isVisible = _c === void 0 ? true : _c, _d = _b.isValidation, isValidation = _d === void 0 ? false : _d;
                var newSources = __assign(__assign({}, state.sources), (_a = {}, _a[filename] = { text: source, tabOrder: tabOrder, isVisible: isVisible, isValidation: isValidation }, _a));
                state.sources = newSources;
            },
            prepare: function (filename, source, tabOrder, isVisible, isValidation) {
                if (isVisible === void 0) { isVisible = true; }
                if (isValidation === void 0) { isValidation = false; }
                return { payload: { filename: filename, source: source, tabOrder: tabOrder, isVisible: isVisible, isValidation: isValidation } };
            },
        },
        setAllValidation: function (state, action) {
            state.validation = action.payload;
        },
        setAllSourcesAndFileMetadata: {
            reducer: function (state, action) {
                var _a = (0, JavalabFileHelper_1.fileMetadataForEditor)(action.payload.sources, action.payload.isEditingStartSources), fileMetadata = _a.fileMetadata, orderedTabKeys = _a.orderedTabKeys, activeTabKey = _a.activeTabKey, lastTabKeyIndex = _a.lastTabKeyIndex;
                var sources = lodash_1.default.cloneDeep(action.payload.sources);
                var updatedSources = (0, JavalabFileHelper_1.updateAllSourceFileOrders)(sources, fileMetadata, orderedTabKeys);
                state.sources = updatedSources;
                state.fileMetadata = fileMetadata;
                state.orderedTabKeys = orderedTabKeys;
                state.activeTabKey = activeTabKey;
                state.lastTabKeyIndex = lastTabKeyIndex;
            },
            prepare: function (sources, isEditingStartSources) {
                return { payload: { sources: sources, isEditingStartSources: isEditingStartSources } };
            },
        },
        renameFile: {
            reducer: function (state, action) {
                var source = state.sources[action.payload.oldFilename];
                // if the old filename doesn't exist, this is a no-op
                if (source !== undefined) {
                    var newSources = __assign({}, state.sources);
                    delete newSources[action.payload.oldFilename];
                    newSources[action.payload.newFilename] = source;
                    state.sources = newSources;
                }
            },
            prepare: function (oldFilename, newFilename) {
                return { payload: { oldFilename: oldFilename, newFilename: newFilename } };
            },
        },
        sourceTextUpdated: {
            reducer: function (state, action) {
                state.sources[action.payload.filename].text = action.payload.text;
            },
            prepare: function (filename, text) {
                return { payload: { filename: filename, text: text } };
            },
        },
        sourceVisibilityUpdated: {
            reducer: function (state, action) {
                state.sources[action.payload.filename].isVisible =
                    action.payload.isVisible;
            },
            prepare: function (filename, isVisible) {
                return { payload: { filename: filename, isVisible: isVisible } };
            },
        },
        sourceValidationUpdated: {
            reducer: function (state, action) {
                state.sources[action.payload.filename].isValidation =
                    action.payload.isValidation;
            },
            prepare: function (filename, isValidation) {
                return { payload: { filename: filename, isValidation: isValidation } };
            },
        },
        sourceFileOrderUpdated: function (state) {
            var sources = lodash_1.default.cloneDeep(state.sources);
            var updatedSources = (0, JavalabFileHelper_1.updateAllSourceFileOrders)(sources, state.fileMetadata, state.orderedTabKeys);
            state.sources = updatedSources;
        },
        removeFile: function (state, action) {
            var filename = action.payload;
            var newSources = __assign({}, state.sources);
            delete newSources[filename];
            state.sources = newSources;
        },
        openEditorDialog: function (state, action) {
            if (Object.values(types_1.JavalabEditorDialog).includes(action.payload)) {
                state.editorOpenDialogName = action.payload;
            }
        },
        closeEditorDialog: function (state) {
            state.editorOpenDialogName = null;
        },
        setEditTabKey: function (state, action) {
            state.editTabKey = action.payload;
        },
        setActiveTabKey: function (state, action) {
            state.activeTabKey = action.payload;
        },
        setFileMetadata: function (state, action) {
            state.fileMetadata = action.payload;
        },
        setOrderedTabKeys: function (state, action) {
            state.orderedTabKeys = action.payload;
        },
        setAllEditorMetadata: {
            reducer: function (state, action) {
                state.fileMetadata = action.payload.fileMetadata;
                state.orderedTabKeys = action.payload.orderedTabKeys;
                state.activeTabKey = action.payload.activeTabKey;
                state.lastTabKeyIndex =
                    action.payload.lastTabKeyIndex || state.lastTabKeyIndex;
            },
            prepare: function (fileMetadata, orderedTabKeys, activeTabKey, lastTabKeyIndex) {
                return {
                    payload: {
                        fileMetadata: fileMetadata,
                        orderedTabKeys: orderedTabKeys,
                        activeTabKey: activeTabKey,
                        lastTabKeyIndex: lastTabKeyIndex,
                    },
                };
            },
        },
        setNewFileError: function (state, action) {
            state.newFileError = action.payload;
        },
        clearNewFileError: function (state) {
            state.newFileError = null;
        },
        setRenameFileError: function (state, action) {
            state.renameFileError = action.payload;
        },
        clearRenameFileError: function (state) {
            state.renameFileError = null;
        },
        setHasCompilationError: function (state, action) {
            state.hasCompilationError = action.payload;
        },
    },
});
// Selectors
var selectSources = function (state) {
    return state.javalabEditor.sources;
};
exports.getSources = (0, toolkit_1.createSelector)(selectSources, function (sources) {
    var result = {};
    for (var key in sources) {
        if (!sources[key].isValidation) {
            result[key] = {
                text: sources[key].text,
                isVisible: sources[key].isVisible,
                tabOrder: sources[key].tabOrder,
            };
        }
    }
    return result;
});
exports.getValidation = (0, toolkit_1.createSelector)(selectSources, function (sources) {
    var validation = {};
    for (var key in sources) {
        if (sources[key].isValidation) {
            validation[key] = {
                text: sources[key].text,
                tabOrder: sources[key].tabOrder,
            };
        }
    }
    return validation;
});
// Exports
exports.setSource = (_a = javalabEditorSlice.actions, _a.setSource), exports.setAllValidation = _a.setAllValidation, exports.setAllSourcesAndFileMetadata = _a.setAllSourcesAndFileMetadata, exports.renameFile = _a.renameFile, exports.sourceTextUpdated = _a.sourceTextUpdated, exports.sourceVisibilityUpdated = _a.sourceVisibilityUpdated, exports.sourceValidationUpdated = _a.sourceValidationUpdated, exports.sourceFileOrderUpdated = _a.sourceFileOrderUpdated, exports.removeFile = _a.removeFile, exports.openEditorDialog = _a.openEditorDialog, exports.closeEditorDialog = _a.closeEditorDialog, exports.setEditTabKey = _a.setEditTabKey, exports.setActiveTabKey = _a.setActiveTabKey, exports.setFileMetadata = _a.setFileMetadata, exports.setOrderedTabKeys = _a.setOrderedTabKeys, exports.setAllEditorMetadata = _a.setAllEditorMetadata, exports.setRenameFileError = _a.setRenameFileError, exports.clearRenameFileError = _a.clearRenameFileError, exports.setNewFileError = _a.setNewFileError, exports.clearNewFileError = _a.clearNewFileError, exports.setHasCompilationError = _a.setHasCompilationError;
exports.default = javalabEditorSlice.reducer;
